<cm-inspector-section>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'id'" [label]="'ID'"></cm-value-slot>
        @if ($curveInput(); as curveInput) {
            <cm-value-slot
                [node]="curveInput"
                [key]="'default'"
                [label]="'Default'"
                [selectionPossibilities]="$curveInputSelectionPossibilities()"
            ></cm-value-slot>
        }
        @if ($referenceFrameInput(); as referenceFrameInput) {
            <cm-value-slot
                [node]="referenceFrameInput"
                [key]="'default'"
                [label]="'Default'"
                [selectionPossibilities]="$referenceFrameInputSelectionPossibilities()"
            ></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>
